@defer (on viewport) {
  <app-banner />
} @placeholder {
  <div>
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}

@defer (on viewport) {
  <app-reason />
} @placeholder {
  <div>
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}

@defer (on viewport) {
  <app-loan-conditions />
} @placeholder {
  <div>
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}

@defer (on viewport) {
  <app-service-info></app-service-info>
} @placeholder {
  <div>
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}
